module.exports = __webpack_public_path__ + "img/11.a6856fb9.jpg";